
import React from "react"
import { Box, Grid, Typography } from "@mui/material"
import { iconos } from "../../../data"




export const CarritoVacio = () => {


  return (
        <Grid item xs={12} sx={{ display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', minHeight:'100%', textAlign:'center'}}>
            <Box sx={{ color:'text.secondary', opacity: 0.6, mt:15 }}>
                {React.cloneElement(iconos['compras'], { 
                  sx: { fontSize: { xs: 60, sm: 80, md: 100 }, color:'white' } 
                })}
            </Box>
      
            <Typography variant="h4" sx={{ fontSize: { xs:'1.5rem', sm:'2rem', md:'2rem' }, fontWeight:600, color:'text.primary'}}>
                Carrito Vacío
            </Typography>
      
            <Typography variant="body1" sx={{ fontSize:{xs:'0.875rem', sm:'1rem'}, color:'text.secondary', maxWidth:'500px', px:2 }}>
                No hay ningún artículo en el carrito de compras.
            </Typography>
        </Grid>
    )
}
